import { render, staticRenderFns } from "./driverJournal.vue?vue&type=template&id=040c3766&scoped=true&"
import script from "./driverJournal.vue?vue&type=script&lang=js&"
export * from "./driverJournal.vue?vue&type=script&lang=js&"
import style0 from "./driverJournal.vue?vue&type=style&index=0&id=040c3766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040c3766",
  null
  
)

export default component.exports